import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import { withRouter } from 'react-router-dom'
import {connect} from 'react-redux'
import ProfileItem from './ProfileItem'

import {SystemSelector} from '/app/src/model/System'
import EmployeeSelector from '/app/src/model/Employee/selector'
import { NotificationSelector } from '/app/src/model/Notification'
class ProfileDisplay extends React.Component {

    constructor(props)
    {
        super(props);

        this._handleClickOutside = this._handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this._handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._handleClickOutside);
    }


    _handleClickOutside(e){
        if (this.props.profileRef && !this.props.profileRef.contains(e.target)){
            this.props.onClickCloseModal('profileDisplay');
        }
    }
    render() {
        return (
            <Flex pos='absolute' backgroundColor='white'>
            <Flex className={style.profileContainer}
                w='300px'
                right='-50px'
                marginRight='0px !important'
                pos='absolute'
                top='10px'
                z='1'
                column>
                    <Flex column padding='0 20px' marginRight='0px !important' borderBottom='2px solid lightgrey'>
                        <h1 className={style.headerText}> {this.props.employeeName} </h1>
                        <Flex className={style.roleText} mb='10px'>{this.props.employeeRole}</Flex>
                    </Flex>
                    <Flex className={style.profileItemWrapper} zIndex={1} column overflow='auto' marginRight='0px !important' h='auto'>
                        <ProfileItem
                            imgSrc='/images/Profile.png'
                            text='Min profil'
                            url='/user/profilepicture'
                            onClickCloseModal={this.props.onClickCloseModal}
                        />
                        <ProfileItem
                            imgSrc='/images/RedCrossMark.png'
                            text='Logga ut'
                            onClickCloseModal= {this.props.onClickCloseModal}
                            logOut
                        />
                    </Flex>
            </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state, ownProps){
    let userId = state.getIn(['user', 'login', 'id'])
    let user = EmployeeSelector.getById(state, userId)
    let userImageUrl = EmployeeSelector.getProfilePicture(user)
    let menuToogle = state.getIn(['system', 'menu', 'toogle'])
    let params = SystemSelector.getParams(state)
    const notifications = NotificationSelector.getNotifications(state);
    let employeeName = EmployeeSelector.getEmployeeName(user);
    let employeeRole = EmployeeSelector.getEmployeeRole(user);
    return {
        userImageUrl: userImageUrl,
        menuToogle: menuToogle,
        params: params,
        notifications: notifications,
        employeeName: employeeName,
        employeeRole: employeeRole
    }
}


export default withRouter(connect(mapStateToProps)(ProfileDisplay));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/ProfileDisplay/index.js